export { Ionic2RatingModule } from './ionic2-rating.module';
export { Ionic2Rating } from './ionic2-rating';
